module.exports = __webpack_public_path__ + "img/male avatar-icon.d72aa284.svg";